
export default {
  mounted() {
    this.$nextTick(() => {
      this.$gsap.set(this.$refs.ring, {
        transformOrigin: 'center',
      })
      this.$gsap.fromTo(
        this.$refs.ring,
        {
          rotate: 0,
        },
        {
          rotation: 360,
          duration: 13,
          repeat: -1,
          ease: 'linear',
        }
      )

      this.$gsap.to('#paint0_linear_831_18314 stop', 2, {
        attr: { offset: '0' },
        repeat: -1,
        yoyo: true,
        repeatDelay: 0.5,
        ease: 'none',
      })
      this.$gsap.to(this.$refs.ring, 2, {
        opacity: 0.3,
        repeat: -1,
        yoyo: true,
        repeatDelay: 0.5,
        ease: 'none',
      })
    })
  },
}
